import { GET_ORDER_QUERY_KEY } from '@src/orders/hooks/useOrder';
import { GET_ORDER_LISTING_QUERY_KEY } from '@src/orders/hooks/useOrderListing';
import { ORDER_LISTING_FILTERED_QUERY_KEY } from '@src/orders/hooks/useOrdersWithFilters';
import { ORDER_CATEGORIES_QUERY_KEYS } from '@src/orders/hooks/useOrderTabs';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateOrderClient = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: string;
  onSuccess: (newClientId: string) => void;
  onError: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (newClientId: string) =>
      OrdersClient.updateClient(orderId, { newClientId }),
    onSuccess: (_, newClientId) => {
      queryClient.invalidateQueries({
        queryKey: [...GET_ORDER_QUERY_KEY, orderId],
      });
      queryClient.invalidateQueries({
        queryKey: [...GET_ORDER_LISTING_QUERY_KEY, orderId],
      });
      queryClient.invalidateQueries({
        queryKey: ORDER_LISTING_FILTERED_QUERY_KEY,
      });
      queryClient.invalidateQueries({ queryKey: ORDER_CATEGORIES_QUERY_KEYS });
      onSuccess(newClientId);
    },
    onError: (error: Error) => {
      onError(error);
    },
  });

  return {
    updateOrderClient: mutate,
    isPending,
  };
};
